import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { project as projectData } from 'app/mock-api/dashboards/project/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class ProjectMockApi {
    private _project: any = projectData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/dashboards/project')
            .reply(() => [200, cloneDeep(this._project)]);

        this._fuseMockApiService
            .onGet('admin/user-financial-details/:id')
            .reply(({ request }) => {
                return [
                    200,
                    {
                        sportsFinancialDetailsDTO: {
                            lastBetAMount: 0.0,
                            totalStakes: 0.0,
                            totalWinnings: 0.0,
                            totalUnSettledStakes: 0.0,
                            bonus: 0.0,
                            profitAndLoss: 0.0,
                            profitability: 0.0,
                            totalBets: 0.0,
                            totalUnSettledBets: 0.0,
                        },
                        casinoFinancialDetailsDTO: {
                            totalStakes: 0.0,
                            totalWinnings: 0.0,
                            totalBonus: 0.0,
                            profitAndLoss: 0.0,
                            profitability: 0.0,
                            lastBet: 0.0,
                        },
                        overallFinancialDetailsDTO: {
                            depositAmount: 0.0,
                            lastDepositAmount: 0.0,
                            depositCount: 0.0,
                            firstDepositDate: null,
                            lastDepositDate: null,
                            withdrawAmount: 0.0,
                            lastWithdrawalAmount: 0.0,
                            withdrawalCount: 0.0,
                            lastWithdrawalDate: null,
                            netRevenue: 0.0,
                        },
                    },
                ];
            });
    }
}
